module.exports = "<p id=\"skip\"><a href=\"#content\">Skip to the content</a></p>\n<div id=\"site\">\n\n  <header>\n    <app-nav-bar></app-nav-bar>\n  </header>\n\n\n  <div id=\"content\">\n    <router-outlet></router-outlet>\n  </div>\n\n  <app-footer></app-footer>\n\n  <span id=\"top-link-block\" class=\"show affix-top hidden-xs\">\n    <a href=\"#top\" onclick=\"$('html,body').animate({scrollTop:0},'slow');return false;\">\n      <i class=\"ion-ios-arrow-up before after\"></i>\n    </a>\n  </span>  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main